import React, { PropsWithChildren } from "react";
import PublicHeader from "./header/PublicHeader";
import Footer from "./Footer";

const PublicLayout: React.FC<PropsWithChildren> = (
  props,
): React.ReactElement => {
  return (
    <div className="flex h-full w-full flex-col">
      <PublicHeader />
      <div className="flex-1 px-4 sm:mx-auto">{props.children}</div>
      <Footer />
    </div>
  );
};

export default PublicLayout;
